"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _AffiliateActiveTagContainer = _interopRequireDefault(require("../../components/AffiliateComponents/AffiliateActiveTagContainer"));
var _AffiliateCountContainer = _interopRequireDefault(require("../../components/AffiliateComponents/AffiliateCountContainer"));
require("./AffiliateLayout.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var affiliateClasses = (0, _cssClassesHelper.getBEMClasses)('affiliate-layout');
var AffiliateComponent = function AffiliateComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  var siteName = props.siteName,
    route = props.route;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: affiliateClasses()
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: affiliateClasses('main-header')
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: affiliateClasses('header')
  }, t("Join the {{n}} Affiliate Program", {
    n: siteName
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: affiliateClasses('description')
  }, t("Our affiliate program lets you earn a bonus for each successful referral registered to your account. Create an affiliate link below, copy it and email to a friend. Your friends can click on the affiliate link and sign up for an account, at which point you will see the number of affliates increase on this page."))), /*#__PURE__*/_react["default"].createElement("section", {
    className: affiliateClasses('body')
  }, /*#__PURE__*/_react["default"].createElement("section", {
    className: affiliateClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: affiliateClasses('container-header')
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: affiliateClasses('container-header--title')
  }, t("Current Active Tag"))), /*#__PURE__*/_react["default"].createElement(_AffiliateActiveTagContainer["default"], {
    route: route
  })), /*#__PURE__*/_react["default"].createElement("section", {
    className: affiliateClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("header", {
    className: affiliateClasses('container-header')
  }, /*#__PURE__*/_react["default"].createElement("h1", {
    className: affiliateClasses('container-header--title')
  }, t("Number of Active Affiliates"))), /*#__PURE__*/_react["default"].createElement(_AffiliateCountContainer["default"], null))));
};
AffiliateComponent.propTypes = {
  route: _propTypes["default"].string.isRequired,
  siteName: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = AffiliateComponent;